import { createTheme } from '@mui/material';
import theme_color from 'resources/theme/theme.colors';

const theme = createTheme({
  components: {
    MuiAccordion: {
      defaultProps: {
        disableGutters: true,
      },
      styleOverrides: {
        root: {
          backgroundColor: 'transparent',
          boxShadow: 'none',
          '&:before': {
            backgroundColor: theme_color.palette.divider,
          },
        },
      },
    },
    MuiAccordionSummary: {
      styleOverrides: {
        root: {
          padding: '8px 0',
          '& .MuiSvgIcon-root': {
            color: theme_color.palette.primary.main,
            fontSize: '24px',
          },
        },
      },
    },
    MuiAccordionDetails: {
      styleOverrides: {
        root: {
          padding: '0',
          marginTop: '24px',
          marginBottom: '32px',
        },
      },
    },
  },
});

export default theme;
